// Force a real download of a (possibly cross-origin) file.
//
// `<a download>` is IGNORED by browsers for cross-origin URLs — our files live
// on the Supabase storage origin, so an <a download> to one just NAVIGATES to
// the file. With no target that happens in the same tab, wiping any unsaved
// work on the page (exactly the "download overwrote my progress" bug).
//
// Fix: fetch the bytes into a SAME-ORIGIN blob URL and download that (the
// download attribute is honoured for blob: URLs). If the fetch is blocked
// (CORS / offline), fall back to opening in a NEW tab — never same-tab
// navigation, so the current page is never lost.
export async function downloadFile(url, filename) {
  if (!url) return;
  const name = filename || (url.split('/').pop() || 'download').split('?')[0];
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
